class LayerView {
	constructor(layer, timeline, orderBy) {
		this.layer = layer;
		this.timeline = timeline;

		this._orderBy = orderBy;
		this._fullHeight = 50;
		this._onHandle = false;
		let buttons = [];

		const canReorder = nav.page != 'dashboard' && (!nav.unit || nav.unit.isAdmin);

		if (nav.page != 'dashboard' && !nav.unit) {
			buttons.push(layerSharing.button(this.layer.id));
		}

		if (nav.unit && nav.entityType == Nav.COMMUNITY && nav.unit.isAdmin) {
			buttons.push(layerAccess.button(this.layer.id));
		}

		if (nav.page != 'dashboard' && (!nav.unit || (nav.entityType == Nav.COMMUNITY && nav.unit.isAdmin))) {
			buttons.push(UI.btn('ed-pri-i-btn px-2 py-1 leading-none', UI.icon('edit', 16), {
				'click': () => this.layer.openRename()
			}, {
				'data-tip': 'above',
				'aria-label': _('Change layer name')
			}));

			buttons.push(UI.btn('ed-pri-i-btn px-2 py-1 leading-none', UI.icon('delete', 16), {
				'click': () => this.layer.delete()
			}, {
				'data-tip': 'above',
				'aria-label': _('Delete this layer')
			}));
		}

		const nameEvents = canReorder ? { 'mousedown touchstart': this.prepReorder.bind(this) } : {};
		this._detailElem = UI.div(
			'layer-name norm' + (this.layer.isReadOnly ? ' locked' : '') + (canReorder ? ' sortable' : ''),
			[this._nameElem = UI.span('', this.layer.name)],
			nameEvents
		);

		const dragChildren = [
			this._eventDiv = UI.div('layer-event-space', [
				this._selectBlock = UI.div('selectArea')
			], {
				'mousedown touchstart': this.mousedown.bind(this)
			}),
			this._detailElem
		];
		if (buttons.length > 0) {
			dragChildren.push(this._ctrlElem = UI.div('layer-ctrl', buttons));
		}

		this._rowElem = UI.div('layer-row', [
			this._dragElem = UI.div('layer-row-inner norm', dragChildren, {
				'mouseover': this.mouseover.bind(this),
				'mouseout': this.mouseout.bind(this)
			})
		]);

		// onEv(this._moreBtn, 'click', this.timeline.layerMore.bind(this.timeline, this));
		this.setHeight();
		// this._rowElem.style.zIndex = timeline.topDownIndex;
	}

	get id() {return this.layer.id;}

	get orderBy() {return this._orderBy;}
	set orderBy(v) {this._orderBy = v;}

	get rowElem() {return this._rowElem;}

	get dragElem() {return this._dragElem;}

	get eventElem() {return this._eventDiv}

	get isActive() {
		return this.layer.activeView == this;
	}

	// set name(v) {
	// 	this._nameElem.innerText = v;
	// }

	activate() {
		this.layer.activate(this);
	}

	getOrder() {return this._orderBy;}

	getRow() {return this._rowElem;}

	getDrag() {return this._dragElem;}

	addEventView(eventView) {
		this._eventDiv.appendChild(eventView);
	}

	setHeight(){
		//TODO check where this function is called - it don't look correct
        this._dragElem.style.height = this.fullHeight + 'px';
	}

	mouseover(ev) {
		this._onHandle = 1;
		if (dragging()) return;

	}

	mouseout() {
		this._onHandle = 0;
		if (dragging()) return;
	}

	mousedown(ev) {
		stopEv(ev);
		if (this.layer.isReadOnly || globalTimeline.selection.isNotEmpty) return;

		this.layer.instances.seekTime(this.timeline.cursorTime(ev));
		globalTimeline.clearActive();
		this.activate();
		this.layer.prepAreaSelect();
		this.layer.cursorTime = this.timeline.cursorTime(ev, SNAP_DISTANCE);

		startDrag(ev, this.layer);
	}

	prepReorder(ev) {
		this.timeline.layerViews.prepDrag(this, ev);
	}

	dropped(ev) {
		API.update(
			`timelines/${this.timeline.id}/layers/${this.layer.id}`,
			{position: this.orderBy}
		)
		.then(reply => showError(reply));
	}

	updateSelectArea(left, width) {
		if (typeof left === 'undefined') {
			this._selectBlock.style.display = 'none';
			return;
		}
		this._selectBlock.style.display = 'block';
		this._selectBlock.style.left = left + 'px';
		this._selectBlock.style.width = width + 'px';
	}
}
